








import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { SurveyElementsUnion } from '@/models/survey-elements-union';
import ComponentPropsManager from '@/helpers/component-props-manager';
import { WidgetPropsUnion } from '@/models/widgets/widget-props-union';

@Component({
  name: 'component-wrapper',
})
export default class ComponentWrapper extends Vue {
  @Model('change') value!: any;
  @Prop({ type: Object, required: true }) field!: SurveyElementsUnion;

  private get componentType(): () => Promise<typeof Vue> {
    return () => import(`@/components/widgets/${this.field.elementType}.vue`);
  }

  private get componentProps(): WidgetPropsUnion {
    return new ComponentPropsManager(this.field).getProps();
  }
}
